module.exports = __webpack_public_path__ + "static/media/add.07d870db.svg";